<template>
  <div>
    <v-card
      class="main--text">
      <v-container
        fluid>
        <v-form>
          <v-row
            no-gutters
            align=center
            justify=space-between>
            <v-col
              cols=auto
              class="font-weight-bold subheading">
              授業依頼画面</v-col>
            <v-col
              cols=auto>
              <v-icon
                @click="$emit('close-button-click')">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              md=2
              ><h5>依頼先</h5>
            </v-col>
          </v-row>
          <v-row
            align=center>
            <v-col
              cols=auto
              class="font-weight-bold subheading">
              <v-avatar>
                <img :src="teacher.iconUrl" alt="">
              </v-avatar>
            </v-col>
            <v-col
              cols=auto
              class="font-weight-bold">
              {{teacher.fullName()}} 先生
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols=auto
              ><h5>対象のお子さま</h5>
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols=auto
              style="font-size: 1.3rem">
                {{ student.fullName() }} さん
            </v-col>
          </v-row>
          <v-row
            dense>
            <v-col>
              <ScheduleSelector
                v-model="schedule"
                :enableToAdd="false"/>
            </v-col>
          </v-row>
          <v-row
            dense>
            <v-col
              cols=12
              md=6
              sm=6>
              <v-select
                v-model="wage"
                :items="wageRange"
                label="一回あたり報酬（円）"
                v-validate="'required|numeric'"
                data-vv-name="wage"
                data-vv-as="報酬"
                required
                :error-messages="errors.collect('wage')"
                ></v-select>
            </v-col>
          </v-row>
          <v-row
            dense>
            <v-col>
              <v-textarea
                v-model="note"
                label="コメント"
                outlined></v-textarea>
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col>
              <v-btn
                rounded
                outlined
                color="primary"
                @click="submit"
                class="font-weight-bold">依頼する
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
    <v-dialog
      :value="submitted"
      width="300">
      <v-card>
        <v-container
          fluid>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              送信完了しました
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                rounded
                outlined
                color="primary"
                @click="$emit('close-button-click')">OK
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ScheduleSelector from "@/components/molecules/ScheduleSelector.vue"
export default {
  components: {
    ScheduleSelector
  },
  props: {
    teacher: {
      type: Object
    },
    student: {
      type: Object
    },
    value: {
      type: Object
    }
  },
  data () {
    return {
      submitted: false
    }
  },
  methods: {
    updateValue (diff) {
      this.$emit("input", { ...this.value, ...diff })
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("submit-button-click")
          this.submitted = true
        }
      })
    }
  },
  computed: {
    wageRange: function () {
      var range = new Array()
      var i
      for (i = 0; i <= 200; i++) {
        range.push(i*100)
      }
      return range
    },
    schedule: {
      get () {
        return this.value.schedule
      },
      set (schedule) {
        this.updateValue({ schedule })
      }
    },
    wage: {
      get() {
        return this.value.wage
      },
      set (wage) {
        this.updateValue({ wage })
      }
    },
    note: {
      get () {
        return this.value.note
      },
      set (note) {
        const reshaped = note.replace("\u21b5", '\n')
        this.updateValue({ note: reshaped })
      }
    }
  }
}
</script>
